import {useIntl as platformIntl} from "@platform/cj-platform-navigation";

export const useIntl = () => {
    return platformIntl();
};
